class SelectClubCtrl
  currentTabIndex: 0
  _selectedClub: undefined

  constructor: (@$scope, @$filter, @$window, @ScoreDataHolderService, @AccordionStateHolderService) ->

  selectTab: (i) ->
    @currentTabIndex = i

  selectClub: (club, isHistory) =>
    if @_selectedClub
      return unless @$window.confirm @$filter('translate')('_SCORE_REGISTRATION.ROUND_INFO.CONFIRM_CLEAR_DATA')
      @ScoreDataHolderService.players = null
      @ScoreDataHolderService.roundInfo = null

    club.isHistory = isHistory if club
    @_selectedClub = club
    @ScoreDataHolderService.club = club
    @AccordionStateHolderService.steps[2].isOpen = false
    @AccordionStateHolderService.steps[3].isOpen = false
    @AccordionStateHolderService.goToStep(1)

SelectClubCtrl.$inject = [
  '$scope'
  '$filter'
  '$window'
  'ScoreDataHolderService'
  'AccordionStateHolderService'
]

module.exports = SelectClubCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/select-club/select-club-controller.coffee